import React, {useState} from 'react';
import {ScrollView, View} from 'react-native';
import {Divider} from 'react-native-paper';

import sy from '~/styles';
import {
  Dialog,
  ServiceRequestStatusIcon,
  Pressable,
  Checkbox,
  Text,
} from '~/components/controls';
import {fleet as fleetApi, rob as robApi} from '~/api/private';
import {isRobTaskCancelled} from '~/types/rob';
import {ROB_REPLACEMENT_CODE, REPLACEMENT_TITLE} from '~/types/replacement';
import {STATUS_DESCRIPTIONS} from '~/types/statuses';

import ReportIcon from '~/images/md-icons/report/materialicons/24px.svg';
import PropTypes from 'prop-types';
const RobDenialsDialog = ({
  visible,
  request_id,
  replacement,
  rob,
  fleet_request,
  onRefresh,
  onDismiss,
}) => {
  const [cancelRequest, setCancelRequest] = useState(
    isRobTaskCancelled(rob?.task_status),
  );

  const [pending, setPending] = useState(false);

  return (
    <Dialog
      visible={visible}
      title={
        <Text style={[sy.largePlus]}>
          {fleet_request ? (
            <>{REPLACEMENT_TITLE}</>
          ) : (
            <>
              {ROB_REPLACEMENT_CODE}&nbsp;&middot;&nbsp;{REPLACEMENT_TITLE}
            </>
          )}
        </Text>
      }
      buttons={[
        {
          text: 'OK',
          textStyle: {color: '#972727'},
          disabled: pending,
          onPress: async () => {
            setPending(true);
            try {
              if (fleet_request) {
                if (cancelRequest) {
                  await fleetApi.cancel_replacement_vehicle(request_id);
                }
              } else if (
                cancelRequest &&
                !isRobTaskCancelled(rob?.task_status)
              ) {
                await robApi.cancel_replacement_vehicle(request_id);
              } else if (
                !cancelRequest &&
                isRobTaskCancelled(rob?.task_status)
              ) {
                await robApi.activate_task(
                  replacement.request_id,
                  rob.rob_id,
                  replacement.request_id,
                );
              }
              await onRefresh();
            } finally {
              setPending(false);
              onDismiss();
            }
          },
        },
      ]}
      onDismiss={pending ? null : onDismiss}
      options={{noPaddingContent: true}}>
      <ScrollView
        style={[sy['p-4']]}
        contentContainerStyle={[{maxHeight: 400}, sy['gap-4']]}>
        <View style={[sy['flex-row'], sy['gap-4']]}>
          <ServiceRequestStatusIcon
            status={replacement?.status}
            height="24"
            width="24"
          />
          <Text>{STATUS_DESCRIPTIONS[replacement?.status]}</Text>
        </View>
        {rob?.denialReasons?.map((reason) => (
          <View key={reason.code} style={[sy['flex-row'], sy['gap-4']]}>
            <View>
              <ReportIcon height={24} width={24} />
            </View>
            <Text>{reason.lessorRemark ?? reason.code}</Text>
          </View>
        ))}
      </ScrollView>
      <Divider style={sy['bg-gray88']} />
      <Pressable
        disabled={pending}
        style={[sy['p-4'], sy['gap-4'], sy['flex-row'], sy['items-center']]}
        onPress={() => setCancelRequest(!cancelRequest)}>
        <Checkbox disabled={pending} checked={cancelRequest} />
        <Text>Activiteit naar vervallen</Text>
      </Pressable>
    </Dialog>
  );
};
RobDenialsDialog.propTypes = {
  visible: PropTypes.any,
  request_id: PropTypes.any,
  replacement: PropTypes.any,
  rob: PropTypes.any,
  fleet_request: PropTypes.any,
  onRefresh: PropTypes.any,
  onDismiss: PropTypes.any,
};

export default RobDenialsDialog;
